import type { FC } from 'react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { RecordVoiceOverIcon } from '@/assets';
import { useBottomModal } from '@/features/popup/provider/useBottomModal';
import { ClosableCard } from '@/features/start/components/components/ClosableCard';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

const styles = StyleSheet.create({
  modalText: {
    paddingHorizontal: 16,
    paddingVertical: 8
  }
});

type GrussVomBuergerMeisterCardProps = {
  mayorGreeting: string;
};

export const GrussVomBuergerMeisterCard: FC<
  GrussVomBuergerMeisterCardProps
> = ({ mayorGreeting }) => {
  const { t } = useTranslation(LocalizationNameSpace.START, {
    keyPrefix: 'components'
  });
  const { showBottomModal } = useBottomModal();

  const handleReadMore = useCallback(() => {
    showBottomModal({
      title: t('grussVomBuergerMeister.title'),
      offsetCloseButton: true,
      children: (
        <Text variant="bodyLarge" style={styles.modalText}>
          {mayorGreeting}
        </Text>
      )
    });
  }, [mayorGreeting, showBottomModal, t]);

  return (
    <ClosableCard
      title={t('grussVomBuergerMeister.title')}
      testId="card-mayor-greeting"
      text={mayorGreeting}
      icon={RecordVoiceOverIcon}
      maxLines={3}
      onMore={handleReadMore}
    />
  );
};

GrussVomBuergerMeisterCard.displayName = 'GrussVomBuergerMeisterCard';
